import { GateConfirmModalForm } from "./GateConfirmModalForm";

const GateConfirmModalFormWrapper = ({
  device,
  setDevice,
  setOpenGateConfirmModal,
  getGateLists,
  listing,
  getListing
}) => {

    return (
      <GateConfirmModalForm
      device={device}
      setDevice={setDevice}
      setOpenGateConfirmModal={setOpenGateConfirmModal}
      getGateLists={getGateLists}
      listing={listing}
      getListing={getListing}
      />
    );
  }

export { GateConfirmModalFormWrapper };
